(function() {
  var STORAGE_KEY = 'bp_cookie_consent';
  var CONSENT_VERSION = 1;
  var EXPIRY_DAYS = 365;

  function readConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (parsed.version !== CONSENT_VERSION) return null;
      var ageDays = (Date.now() - new Date(parsed.timestamp).getTime()) / 86400000;
      if (ageDays > EXPIRY_DAYS) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveConsent(choice) {
    var record = {
      choice: choice,
      timestamp: new Date().toISOString(),
      version: CONSENT_VERSION
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (e) {
    }
  }

  function applyConsent(choice) {
    if (choice === 'all') {
      if (typeof gtag === 'function') {
        gtag('consent', 'update', {
          'analytics_storage': 'granted',
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted'
        });
      }
      loadHotjar();
      loadApollo();
    }
  }

  function loadHotjar() {
    if (window.__bp_hotjar_loaded) return;
    window.__bp_hotjar_loaded = true;
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:633873,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }

  function loadApollo() {
    if (window.__bp_apollo_loaded) return;
    window.__bp_apollo_loaded = true;
    var n = Math.random().toString(36).substring(7);
    var o = document.createElement('script');
    o.src = 'https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=' + n;
    o.async = true;
    o.defer = true;
    o.onload = function() {
      if (window.trackingFunctions && typeof window.trackingFunctions.onLoad === 'function') {
        window.trackingFunctions.onLoad({ appId: '66338034da032001c777a3aa' });
      }
    };
    document.head.appendChild(o);
  }

  function showBanner() {
    var banner = document.getElementById('bp-cookie-notice');
    if (!banner) return;
    banner.classList.add('is-visible');
    banner.setAttribute('aria-hidden', 'false');
    var primary = banner.querySelector('[data-consent="all"]');
    if (primary) primary.focus();
  }

  function hideBanner() {
    var banner = document.getElementById('bp-cookie-notice');
    if (!banner) return;
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
  }

  function bindBanner() {
    var banner = document.getElementById('bp-cookie-notice');
    if (!banner) return;

    var suppressedByCart = false;
    function syncBannerToCart() {
      if (document.body.classList.contains('js-drawer-open-cart')) {
        if (banner.classList.contains('is-visible')) { hideBanner(); suppressedByCart = true; }
      } else if (suppressedByCart) {
        suppressedByCart = false;
        if (!readConsent()) showBanner();
      }
    }
    new MutationObserver(syncBannerToCart).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    var acceptBtn = banner.querySelector('[data-consent="all"]');
    if (acceptBtn) {
      acceptBtn.addEventListener('click', function() {
        saveConsent('all');
        applyConsent('all');
        hideBanner();
      });
    }

    var essentialBtn = banner.querySelector('[data-consent="essential"]');
    if (essentialBtn) {
      essentialBtn.addEventListener('click', function() {
        saveConsent('essential');
        applyConsent('essential');
        hideBanner();
      });
    }

    var closeBtn = banner.querySelector('[data-consent="close"]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        saveConsent('essential');
        applyConsent('essential');
        hideBanner();
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && banner.classList.contains('is-visible')) {
        saveConsent('essential');
        applyConsent('essential');
        hideBanner();
      }
    });
  }

  function init() {
    bindBanner();
    var stored = readConsent();
    if (stored) {
      applyConsent(stored.choice);
    } else {
      showBanner();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
